import { useState, useEffect } from 'react';
import {State as DataState, CompositeFilterDescriptor} from '@progress/kendo-data-query';

const sanitizeDateFilters = (filter: CompositeFilterDescriptor | undefined): CompositeFilterDescriptor | undefined => {
    if (!filter || !filter.filters) return filter;

    return {
        ...filter,
        filters: filter.filters.map((f: any) => {
            if (f.filters) {
                return sanitizeDateFilters(f);
            }

            if (f.field === 'updatedAt' && f.operator === 'eq') {
                return { ...f, operator: 'gte' };
            }
            return f;
        }),
    };
};
const restoreDates = (filter: CompositeFilterDescriptor | undefined): CompositeFilterDescriptor | undefined => {
    if (!filter || !filter.filters) return filter;

    return {
        ...filter,
        filters: filter.filters.map((f: any) => {
            if (f.filters) {
                return restoreDates(f);
            }
            const isDateString = typeof f.value === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(f.value);

            if (isDateString) {
                return { ...f, value: new Date(f.value) };
            }
            return f;
        }),
    };
};

export const useGridPersist = (key: string, initialState: DataState) => {
    const [state, setState] = useState<DataState>(() => {
        try {
            const savedItem = localStorage.getItem(key);
            if (savedItem) {
                const parsedState = JSON.parse(savedItem);

                if (parsedState.filter) {
                    parsedState.filter = restoreDates(parsedState.filter);
                    parsedState.filter = sanitizeDateFilters(parsedState.filter);
                }

                return parsedState;
            }
        } catch (error) {
            console.error('Error reading grid state from localStorage', error);
        }
        return initialState;
    });

    useEffect(() => {
        try {
            localStorage.setItem(key, JSON.stringify(state));
        } catch (error) {
            console.error('Error saving grid state to localStorage', error);
        }
    }, [key, state]);

    return [state, setState] as const;
};
